import React from 'react';
import { ParallaxImage } from '../ui/ParallaxImage';
import { RevealOnScroll } from '../ui/RevealOnScroll';
import { TextLink } from '../ui/TextLink';
export function Currently() {
  return <section id="studio" className="bg-taupe py-20 md:py-[120px] overflow-hidden" data-id="element-76">
      {/* Header */}
      <RevealOnScroll data-id="element-77">
        <div className="px-6 md:pl-[80px] md:pr-12 mb-16 md:mb-24" data-id="element-78">
          <p className="font-mono text-[12px] tracking-[0.2em] uppercase text-parchment mb-4" data-id="element-79">
            CHAPTER ONE.
          </p>
          <h2 className="font-serif italic text-parchment text-[36px] md:text-[64px] leading-[1.05]" data-id="element-80">
            Currently in the studio.
          </h2>
        </div>
      </RevealOnScroll>

      {/* Two-column editorial spread */}
      <div className="grid grid-cols-1 md:grid-cols-2 md:gap-0 items-stretch" data-id="element-81">
        {/* Left column — Image */}
        <RevealOnScroll className="w-full" data-id="element-82">
          <ParallaxImage src="https://cdn.magicpatterns.com/uploads/hmEoMBKpCMKTKNZAxU8LTb/spaces-design4.jpg" alt="A studio moodboard of warm interiors, brass, leather, and antlers" className="w-full aspect-[4/5]" data-id="element-83" />
        </RevealOnScroll>

        {/* Right column — Journal entry */}
        <RevealOnScroll className="w-full" delay={0.15} data-id="element-84">
          <div className="h-full flex items-center px-6 md:pl-[80px] md:pr-12 py-16 md:py-0" data-id="element-85">
            <div className="max-w-xl" data-id="element-86">
              {/* Brass line */}
              <div className="w-[60px] h-[1px] bg-brass mb-8" data-id="element-87"></div>

              {/* Date label */}
              <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-brass mb-8" data-id="element-88">
                OCTOBER 2025
              </p>

              {/* Journal entry */}
              <div className="font-mono text-parchment/95 text-[16px] md:text-[15px] leading-[1.9] space-y-6" data-id="element-89">
                <p data-id="element-90">
                  A new build in Paradise Valley. The clients want a home that
                  feels like the desert at dusk. We are weaving stained glass,
                  walnut, and aged brass into every quiet corner.
                </p>
                <p data-id="element-91">
                  The kitchen is the first chapter we are writing together. A
                  long banquette under a south-facing window. Hand glazed tile
                  the color of wet stone. A pendant light that throws shadows
                  the way candles used to.
                </p>
                <p data-id="element-92">
                  Some weeks the work is loud. Floor plans, finish samples,
                  calls with the contractor. Other weeks it is quiet. A single
                  fabric draped over a chair until it is right.
                </p>
                <p data-id="element-93">Both are part of the same story.</p>
              </div>

              {/* Read more link */}
              <div className="mt-10" data-id="element-94">
                <TextLink href="#journal" className="text-brass text-[14px]" underlineColor="border-brass" data-id="element-95">
                  read the full journal &rarr;
                </TextLink>
              </div>
            </div>
          </div>
        </RevealOnScroll>
      </div>
    </section>;
}